//This is a helper component to wrap conditionally rendered components in
//Its the same as the built in React way, but this allows for nested conditionals and a cleaner look
export default function Conditional(props) {
    return (
        !!props.if && props.children
    )
}
